/**
 * @generated SignedSource<<e0f2a01bfef16bd6a4ece39dde74ef70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationBasedFiltersModalFragment_facility$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CourseBucketFilterControlFragment_facility" | "DateSelectorControlFragment_facility" | "DurationFilterControlFragment_facility" | "facilityToScheduleOption_facility" | "useFacilityGroupSize_facility" | "useFacilityStartEndTime_facility">;
  readonly " $fragmentType": "DurationBasedFiltersModalFragment_facility";
};
export type DurationBasedFiltersModalFragment_facility$key = {
  readonly " $data"?: DurationBasedFiltersModalFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedFiltersModalFragment_facility">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationBasedFiltersModalFragment_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityStartEndTime_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityGroupSize_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CourseBucketFilterControlFragment_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DurationFilterControlFragment_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DateSelectorControlFragment_facility"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "facilityToScheduleOption_facility",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "4d2eeb398fa2c72b684a4f09659974f5";

export default node;
